import { render, staticRenderFns } from "./StandappResetPasswordComponent.vue?vue&type=template&id=6eb07396&"
import script from "./StandappResetPasswordComponent.vue?vue&type=script&lang=js&"
export * from "./StandappResetPasswordComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports